var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-date-picker", {
    attrs: {
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "開始日",
      "end-placeholder": "結束日",
      "default-time": ["00:00:00", "23:59:59"],
      "value-format": "yyyy-MM-dd",
      clearable: false,
    },
    on: {
      change: _vm.onChange,
      click: function ($event) {
        this.date = null
        _vm.onChange
      },
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v
      },
      expression: "date",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }